module.exports = __webpack_public_path__ + "img/图像25.b96ca287.png";